module.exports = __webpack_public_path__ + "static/img/10bg_3.0b8d054.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/10bg_3.png
// module id = 610
// module chunks = 1